import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@consentropy/shared';
import { QueryProvider } from '@consentropy/shared';
import { AuthProvider } from '@consentropy/shared';
import { router } from './routes';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
